(function () {
  if (window.IzzatAddToCartEnhancements) return;
  window.IzzatAddToCartEnhancements = true;

  function text(selector, root) {
    var el = (root || document).querySelector(selector);
    return el ? el.textContent.trim() : '';
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[char];
    });
  }

  function fmtPriceFromText(value) {
    return (value || '').trim().replace(/\s+/g, ' ');
  }

  function getSelectedTotal() {
    var selected = document.querySelector('input[name="quantity"]:checked');
    if (!selected) return null;

    var label = document.querySelector('label[for="' + selected.id + '"]');
    var priceEl = label && label.querySelector('.quantity-break__price');
    return priceEl ? fmtPriceFromText(priceEl.textContent) : null;
  }

  function updateAtcPrices() {
    var price = getSelectedTotal();
    document.querySelectorAll('[data-atc-price]').forEach(function (el) {
      if (price) {
        el.textContent = price;
        el.setAttribute('data-ready', 'true');
      } else {
        el.textContent = '';
        el.setAttribute('data-ready', 'false');
      }
    });
  }

  function getCurrentVariantTitle() {
    var checkedVariant = document.querySelector(
      'variant-picker input[type="radio"]:checked, fieldset[data-option-position] input[type="radio"]:checked'
    );
    if (checkedVariant) return checkedVariant.value || '';

    var select = document.querySelector('variant-picker select, select[name="id"]');
    if (select && select.options[select.selectedIndex]) {
      return select.options[select.selectedIndex].text;
    }

    return '';
  }

  function getCurrentQuantityAndPrice() {
    var quantityInput = document.querySelector('input[name="quantity"]:checked');
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
    var priceText = '';

    if (quantityInput) {
      var label = document.querySelector('label[for="' + quantityInput.id + '"]');
      var priceEl = label && label.querySelector('.quantity-break__price');
      if (priceEl) priceText = priceEl.textContent.trim();
    }

    return {
      quantity: Number.isFinite(quantity) ? quantity : 1,
      priceText: priceText,
    };
  }

  function openCartDrawer() {
    requestAnimationFrame(function () {
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        try {
          drawer.open();
        } catch (err) {}
      } else if (drawer && typeof drawer.showDialog === 'function') {
        try {
          drawer.showDialog();
        } catch (err) {}
      }
    });
  }

  function injectOptimisticItem() {
    try {
      var drawer = document.querySelector('cart-drawer-component');
      if (!drawer) return;

      var wrapper = drawer.querySelector('.cart-items__wrapper, .cart-drawer__items');
      if (!wrapper) return;

      var emptyHeading = drawer.querySelector('.cart-drawer__heading--empty');
      if (emptyHeading) emptyHeading.style.display = 'none';

      var existing = drawer.querySelector('.alpha-optimistic-item');
      if (existing) existing.remove();

      var quantityInfo = getCurrentQuantityAndPrice();
      var variantTitle = getCurrentVariantTitle();
      var image = document.querySelector('.product-media-container img.product-media__image, media-gallery img');
      var imageSrc = image && (image.currentSrc || image.src);
      var productTitle = text('.product-title, h1.product-information__title, h1') || 'Tema Izzat';

      var item = document.createElement('div');
      item.className = 'alpha-optimistic-item';
      item.setAttribute('data-optimistic', 'true');
      item.innerHTML =
        '<div class="alpha-opt-row">' +
        (imageSrc
          ? '<img class="alpha-opt-img" src="' +
            escapeHtml(imageSrc) +
            '" alt="' +
            escapeHtml(productTitle) +
            '" loading="eager" decoding="sync">'
          : '<div class="alpha-opt-img"></div>') +
        '<div class="alpha-opt-info">' +
        '<div class="alpha-opt-title">' +
        escapeHtml(productTitle) +
        '</div>' +
        '<div class="alpha-opt-variant">' +
        (variantTitle ? escapeHtml(variantTitle) + ' &middot; ' : '') +
        quantityInfo.quantity +
        'x</div>' +
        (quantityInfo.priceText ? '<div class="alpha-opt-price">' + escapeHtml(quantityInfo.priceText) + '</div>' : '') +
        '<div class="alpha-opt-status">Adding to cart...</div>' +
        '</div></div>';

      wrapper.prepend(item);
    } catch (err) {}
  }

  function removeOptimisticItems() {
    document.querySelectorAll('.alpha-optimistic-item').forEach(function (el) {
      el.remove();
    });

    var emptyHeading = document.querySelector('.cart-drawer__heading--empty');
    if (emptyHeading) emptyHeading.style.display = '';
  }

  function bindEvents() {
    updateAtcPrices();

    document.addEventListener('change', function (event) {
      if (event.target && event.target.name === 'quantity') updateAtcPrices();
    });
    document.addEventListener('quantity-update', updateAtcPrices);
    document.addEventListener('variant:change', updateAtcPrices);

    document.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest && event.target.closest('button[name="add"]:not([disabled])');
        if (!button || button.closest('.quick-add-modal')) return;

        openCartDrawer();
        setTimeout(injectOptimisticItem, 0);
      },
      { capture: true, passive: true }
    );

    document.addEventListener('cart:update', removeOptimisticItems);
    document.addEventListener('cart:add', function () {
      setTimeout(removeOptimisticItems, 50);
    });

    var ticks = 0;
    var poll = setInterval(function () {
      updateAtcPrices();
      ticks += 1;
      if (ticks > 20) clearInterval(poll);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindEvents, { once: true });
  } else {
    bindEvents();
  }
})();
